import PaletteWebglProgram from "./paletteWebglProgram";

export default class LinearPaletteWebglProgram extends PaletteWebglProgram{
  constructor(vert, frag){
    super(vert, frag);

    this.slopeLocation = null;
    this.offsetLocation = null;
  }

  prepareLocations(gl){
    super.prepareLocations(gl);
    this.slopeLocation = gl.getUniformLocation(this.program, "u_slope");
    this.offsetLocation = gl.getUniformLocation(this.program, "u_offset");
  }

  setThicknessMapColorSettings(gl, thicknessMapColorSettings){
    super.setThicknessMapColorSettings(gl, thicknessMapColorSettings);
    gl.uniform1f(this.slopeLocation, thicknessMapColorSettings.linearAdjustment.slope);
    gl.uniform1f(this.offsetLocation, thicknessMapColorSettings.linearAdjustment.offset);
  }
}